/** Badge/pill pour afficher un statut */

import { cn } from '../../lib/utils';

const variants = {
  success: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  danger: 'bg-rose-50 text-rose-700 border-rose-200',
  warning: 'bg-amber-50 text-amber-700 border-amber-200',
  neutral: 'bg-stone-100 text-stone-600 border-stone-200',
  info: 'bg-accent-soft text-accent border-accent/30',
} as const;

interface BadgeProps {
  variant?: keyof typeof variants;
  children: React.ReactNode;
  className?: string;
}

export function Badge({ variant = 'neutral', children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border',
        variants[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
